import React from "react";
import Home from '../assets/home.png';
import Earn from '../assets/earn.png';
import Invite from '../assets/invite.png';
import Settings from '../assets/settings.png';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

const Container = {
    width: '100vw',
    maxWidth: '100vw',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    zIndex: '2',
    fontFamily: 'SpaceGrotesk-SemiBold',
    

};

const InnerWrapper = {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    position: 'relative',
    zIndex: '505',
    paddingTop: '7.5px',
    paddingBottom: '7.5px',
    overflow: 'hidden',
    zIndex: '2',
    backgroundColor: 'transparent',
    borderTopLeftRadius: '25px',
    borderTopRightRadius: '25px',
};

const FooterImage = {
    width: '22.5px',
    height: '22.5px',
};

const Button = {
    backgroundColor: 'transparent',
    border: '2px solid transparent',
    borderRadius: '15px',
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '7.5px',

};

const HoveredButton = {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
};

const ButtonText = {
    fontSize: '10px',
    color: 'rgba(193, 202, 222, 1)',
    fontWeight: 'bold',
    marginTop: '5px',
};

const Footer = () => {

    const navigate = useNavigate();

    return (
        <div style={Container}>
            <div style={InnerWrapper}>
                <button onClick={() => navigate('/')} style={Button}>
                    <img src={Home} style={FooterImage} />
                    <h1 style={ButtonText}>HOME</h1>
                </button>
                <button onClick={() => navigate('/earn')} style={Button}>
                    <img src={Earn} style={FooterImage} />
                    <h1 style={ButtonText}>EARN</h1>
                </button>
                <button onClick={() => navigate('/invite')} style={Button}>
                    <img src={Invite} style={FooterImage} />
                    <h1 style={ButtonText}>INVITE</h1>
                </button>
                <button onClick={() => navigate('/about')} style={Button}>
                    <img src={Settings} style={FooterImage} />
                    <h1 style={ButtonText}>ABOUT</h1>
                </button>
            </div>
        </div>

    )
};

export default Footer;